import { FC, useEffect } from "react";

const LayoutSplashScreen: FC = () => {
  useEffect(() => {
    document.body.classList.add("page-loading");

    return () => {
      document.body.classList.remove("page-loading");
    };
  }, []);

  return null;
};

export default LayoutSplashScreen;
